"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Flex = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1gzsnzu0"
})(_base.default, ";", _font.default, ";display:flex;flex-wrap:", function (props) {
  return props.flexWrap ? props.flexWrap : 'nowrap';
}, ";justify-content:", function (props) {
  return props.justifyContent ? props.justifyContent : 'flex-start';
}, ";flex-direction:", function (props) {
  return props.flexDirection ? props.flexDirection : 'row';
}, ";align-items:", function (props) {
  return props.alignItems ? props.alignItems : 'stretch';
}, ";align-content:", function (props) {
  return props.alignContent ? props.alignContent : 'stretch';
}, ";background-color:", function (props) {
  return props.backgroundColor ? props.backgroundColor : 'transparent';
}, ";color:", function (props) {
  return props.color ? props.color : (0, _utils.getTextColor)(props);
}, ";border:", function (props) {
  return props.border ? props.border : 0;
}, ";border-radius:", function (props) {
  return props.borderRadius ? props.borderRadius : 0;
}, ";box-shadow:", function (props) {
  return props.boxShadow ? props.boxShadow : 'none';
}, ";margin:", function (props) {
  return props.margin ? props.margin : 0;
}, ";padding:", function (props) {
  return props.padding ? props.padding : 0;
}, ";");
var _default = Flex;
exports.default = _default;